<template>
  <layout-main-inner title="企业专用标签">
    <el-button type="primary"
               slot="action"
               v-if="userPermission.OPERATE"
               @click="createTagScanUrlPre">新增扫码地址前缀</el-button>
    <layout-card-wrap>
      <el-tabs v-model="activeTab">
        <el-tab-pane label="非套码"
                     name="1">
          <ent-tag-distribution-table ref="tag"
                                      :callback="cbTag" />
        </el-tab-pane>
        <el-tab-pane label="套码"
                     name="2">
          <ent-set-distribution-table ref="set"
                                      :callback="cbSet" />
        </el-tab-pane>
      </el-tabs>
    </layout-card-wrap>
    <url-pre-modal ref="url" k="preassign_tag_scan_url_pres"
                   v-if="userPermission.OPERATE" />
  </layout-main-inner>
</template>

<script>
import EntTagDistributionTable from './busi/ent-tag-distribution-table.vue'
import EntSetDistributionTable from './busi/ent-set-distribution-table.vue'
import UrlPreModal from './urlPre/url-pre-modal.vue'
import { mapState } from 'vuex'
export default {
  name: 'ent-label',
  components: { EntTagDistributionTable, EntSetDistributionTable, UrlPreModal },
  props: {},
  data () {
    return {
      activeTab: '1'
    }
  },
  computed: {
    ...mapState({
      userPermission: state => state.account.permission
    })
  },
  methods: {
    cbTag () {
      this.$refs.tag.handleProduceChange(1)
    },
    cbSet () {
      this.$refs.set.handleProduceChange(1)
    },
    createTagScanUrlPre () {
      this.$refs.url.init()
    }
  },
  created () { },
  mounted () { }
}
</script>
<style lang="stylus">
.el-table__expanded {
  .el-table__expanded-cell {
    padding: 0 !important;
    border: none;
  }

  .el-table__expanded-cell td {
    border-right: none;
  }
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>
